import styled from "styled-components"

const ContentCardStyle = styled.div`
    border: 1px solid #E1E6E7;
    border-radius: 8px;
    padding: 15px;
`

export default ContentCardStyle